import { DrawerStyles } from 'antd/es/drawer/DrawerPanel';
import { PropsWithChildren, ReactNode } from 'react';

import { CapSidebar } from 'ui/sidebar';

export type GraphSetSidebarPlacement = 'right' | 'bottom';

interface Props {
  title: ReactNode;
  visible: boolean;
  onClose: () => void;
  footer?: ReactNode;
  styles?: DrawerStyles;
  placement?: GraphSetSidebarPlacement;
  closable?: boolean;
}

const GraphSetSidebar = ({
  title,
  visible,
  onClose,
  children,
  footer,
  styles,
  placement = 'right',
  closable = false,
}: PropsWithChildren<Props>) => {
  return (
    <CapSidebar
      onClose={onClose}
      // it is actually closable, but this remove the default close icon
      closable={closable}
      title={title}
      open={visible}
      height="80vh"
      width="35vw"
      footer={footer}
      styles={styles}
      placement={placement}
    >
      {children}
    </CapSidebar>
  );
};

export default GraphSetSidebar;
